import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/sports/icon-live.svg")